import styled from 'styled-components'

export const DashboardAlarmListContainer = styled.div`
    flex: 1;
    width: 100%;
    height: calc(100% + 10px);

    position: relative;
    background: var(--gray-0);
    padding: 16px 8px 8px 16px;
    border-radius: 4px 0px 0px 0px;
    .filter-row {
        display: flex;
        align-items: center;

        .filter-button {
            width: 322px;
            border-radius: 3px 0px 0px 3px;
            padding: 8px 12px;
            border: 1px solid var(--gray-400);
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            i {
                font-size: 13px;
                color: var(--blue-500);
            }

            .icon-label-bundle {
                display: flex;
                gap: 6px;
                align-items: center;
            }
        }

        .order-button {
            font-size: 16px;
            color: var(--blue-500);
            width: 44px;
            padding: 8px 16px;
            border-radius: 0px 3px 3px 0px;
            border: 1px solid var(--gray-400);
            border-left: none;
            cursor: pointer;
        }
    }
    .list-filter {
        display: flex;
        gap: 10px;
        margin-top: 5px;
        margin-bottom: 10px;

        &.second-row {
            align-items: center;
            .tags-row {
                display: flex;
                flex-direction: row;
                width: calc(100% - 190px);
                gap: 8px;
                flex-wrap: wrap;

                .selected-tag {
                    display: flex;
                    flex-wrap: wrap;
                    border: 1px solid ${({ theme }) => theme['gray-600']};
                    gap: 8px;
                    padding: 2px 8px;
                    border-radius: 3px;
                    /* max-width: 40%; */
                    height: 22px;
                    font-size: 12px;
                    font-weight: 600;
                    color: ${({ theme }) => theme['gray-600']};
                    align-items: center;
                    cursor: default;
                }

                .fa-times {
                    color: ${({ theme }) => theme['gray-600']};
                    cursor: pointer;
=                }
            }
            .selected-filter {
                width: 110px;
            }
            .clear {
                width: 80px;
                display: flex;
                justify-content: end;

                .clear-label {
                    color: ${({ theme }) => theme['blue-500']};
                    font-size: 11px;
                    font-weight: 400;
                    cursor: pointer;
                }
            }
        }
    }
    .select-dropdown {
        width: 322px;
        display: flex;
        flex-direction: column;
        padding: 16px;
        gap: 16px;
        position: absolute;
        background: var(--gray-0);
        top: 56px;
        right: 0px;
        box-shadow: 0px 4px 6px rgba(161, 174, 191, 0.25);
        border-radius: 3px;
        border: 1px solid var(--gray-400);
        background: var(--gray-0);
        z-index: 90;
    }
    .sort-dropdown {
        width: 192px;
        position: absolute;
        background: var(--gray-0);
        top: 56px;
        right: 240px;
        box-shadow: 0px 4px 6px rgba(161, 174, 191, 0.25);
        border-radius: 3px;
        border: 1px solid var(--gray-400);
        display: flex;
        flex-direction: column;
        gap: 9px;
        background: var(--gray-0);
        z-index: 90;
        .items-filter {
            display: flex;
            justify-content: center;
            font-size: 13px;
            font-weight: 400;
            padding: 9.5px 0;
            cursor: pointer;
        }

        .divider {
            border: 0.25px solid ${({ theme }) => theme['gray-600']};
        }
    }
`

export const CardList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: scroll;
    height: calc(100% - 62px);
`
